import React from 'react'
import { Box, Typography } from '@mui/material'
import { Button, Modal } from '@/design-system'

export interface DeleteGalleryModalProps {
  open: boolean
  galleryName: string
  onClose: () => void
  onConfirm: () => void
}

export function DeleteGalleryModal({ open, galleryName, onClose, onConfirm }: DeleteGalleryModalProps) {
  return (
    <Modal open={open} onClose={onClose} title='Delete gallery?'>
      <Typography sx={{ fontSize: 14, color: 'var(--ds-ink-muted)', mb: 3 }}>
        “{galleryName}” and its scene, frame, and photo placements will be permanently deleted. The
        source album is not affected.
      </Typography>
      <Box display='flex' justifyContent='flex-end' gap={1.5}>
        <Button variant='ghost' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='danger'
          onClick={() => {
            onConfirm()
            onClose()
          }}
        >
          Delete
        </Button>
      </Box>
    </Modal>
  )
}
